module.exports = __webpack_public_path__ + "assets/img/young_program_1.088efc65.png";